import {
  HubXAnalytics,
  PlatformEnum,
} from '@hubxtech/hubx-client-analytics-package/apps/pdf-genius';
import { AppsEnum } from '@hubxtech/hubx-client-analytics-package/lib/src/enum/appsEnum';

const app =
  process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'
    ? AppsEnum.PDF_GENIUS
    : AppsEnum.PDF_GENIUS_DEV;

export const hubxAnalyticsApp = app;

export const hubxAnalytic = new HubXAnalytics({
  app: app,
  platform: PlatformEnum.WEB, // Assuming 'WEB' for Next.js app
  pauseEventSending: false, // Set to true to disable event sending
  cookieDomain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN,
});
